import { Id } from "@dgs/core";
import { FC } from "react";

import { EditBaseApplicationDrawer } from "../applications/EditBaseApplicationsDrawer";
import { EditParticipantManagementApplicationDrawer } from "../applications/EditParticipantManagementApplicationDrawer";
import { ApplicationType } from "../shared/types/application";

interface Props {
	open: boolean;
	onClose: () => void;
	applicationType: ApplicationType;
	entityId: Id;
	eventId?: Id;
}

export const EditApplicationDrawer: FC<Props> = ({ applicationType, ...props }) => {
	switch (applicationType) {
		case ApplicationType.PARTICIPANT_MANAGEMENT:
			return <EditParticipantManagementApplicationDrawer {...props} />;
		default:
			return <EditBaseApplicationDrawer applicationType={applicationType} {...props} />;
	}
};
